class card extends HTMLElement {
  activeClass = 'active';

  constructor() {
    super();
  }

  connectedCallback() {

    // Add intersection observer to toggle active class when it is in/out of view.
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
    };

    // Create an Intersection Observer for the custom element itself.
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        const intersectionRatioX = entry.intersectionRect.width / entry.boundingClientRect.width;
        if (intersectionRatioX >= 0.8) {
          this.addActiveClass();
        } else {
          this.removeActiveClass();
        }
      });
    }, options);

    // Start observing the custom element.
    observer.observe(this);
  }

  addActiveClass() {
    this.classList.add(this.activeClass);
  }

  removeActiveClass() {
    this.classList.remove(this.activeClass);
  }

  disconnectedCallback() {
    observer.unobserve(this);
  }
}

class ArticleCard extends card {
  constructor() {
    super();
  }
}

window.customElements.define('article-card', ArticleCard);
